import PropTypes from "prop-types"
import React from "react"
import { Controller, useFormContext } from "react-hook-form"

import Form from "src/components/Form"
import { ADD_NEW_PAYMENT_METHOD } from "src/components/SelectPaymentMethod/SelectPaymentMethod"

import InvoiceAutopayFields from "./InvoiceAutopayFields"

const GenerateInvoiceDetailsStep = ({
  contact,
  workOrder,
  workOrderSequentialId,
}) => {
  const { control, watch, setValue } = useFormContext()
  const autopayEnabled = watch("autopayEnabled")

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-1">
        <Form.Label htmlFor="dueDate">Due date</Form.Label>
        <Controller
          name="dueDate"
          control={control}
          render={({ field }) => (
            <Form.DatePicker
              id="dueDate"
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
      </div>

      <Controller
        name="stripePaymentMethodId"
        control={control}
        rules={{
          validate: (value) =>
            !autopayEnabled ||
            (Boolean(value) && value !== ADD_NEW_PAYMENT_METHOD) ||
            "Select a payment method to enable AutoPay.",
        }}
        render={({ field, fieldState }) => (
          <div className="flex flex-col gap-1">
            <InvoiceAutopayFields
              workOrderSequentialId={workOrderSequentialId}
              contactId={workOrder?.contact?.id}
              enabled={Boolean(autopayEnabled)}
              onEnabledChange={(value) =>
                setValue("autopayEnabled", value, { shouldDirty: true })
              }
              stripePaymentMethodId={field.value || ""}
              onPaymentMethodChange={field.onChange}
              woDefaultEnabled={Boolean(workOrder?.autopayEnabled)}
            />
            {fieldState.error && (
              <Form.Error>{fieldState.error.message}</Form.Error>
            )}
          </div>
        )}
      />

      <Controller
        name="sendEmail"
        control={control}
        render={({ field }) => (
          <Form.Checkbox
            name="sendEmail"
            checked={!!field.value}
            onChange={(e) => field.onChange(e.target.checked)}
            labelClassName="m-0 ml-2"
          >
            <div className="flex flex-col">
              <span className="text-gray-900">
                Email invoice to {contact?.name}
              </span>
              {contact?.email ? (
                <span className="text-sm text-gray-500">{contact.email}</span>
              ) : (
                <span className="text-sm text-gray-400">No email on file</span>
              )}
            </div>
          </Form.Checkbox>
        )}
      />
    </div>
  )
}

GenerateInvoiceDetailsStep.propTypes = {
  contact: PropTypes.shape({ name: PropTypes.string, email: PropTypes.string }),
  workOrder: PropTypes.shape({
    autopayEnabled: PropTypes.bool,
    contact: PropTypes.shape({ id: PropTypes.string }),
  }),
  workOrderSequentialId: PropTypes.string.isRequired,
}

export default GenerateInvoiceDetailsStep
